import styled from 'styled-components';

import { flexCenter, flexEnd } from '../../../style/reusableStyle';

export const ReviewAndSendContainerStyled = styled.div`
  margin-bottom: 50px;
`;

export const IndividualSelectedPDFWrapperStyled = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 20px;
  margin-bottom: 20px;
  flex-direction: row;

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    flex-direction: column;
  }
`;

export const RemoveAdditionalNotesStyled = styled.div`
  ${flexEnd(0)};

  & svg {
    cursor: pointer;
    path {
      stroke: red;
    }
  }
`;

export const UploadAndSendToReviewContainerStyled = styled.div``;
export const SentForReviewContainerStyled = styled.div`
  & .section-title {
    margin-bottom: 10px;
  }
  & .individual-pdf-container {
    margin-bottom: 20px;

    & .pdf-title {
      margin-bottom: 8px;
    }
  }

  & .individual-notes-container {
    margin-bottom: 20px;
  }
`;

export const ReviewedByEscPlanContainerStyled = styled.div`
  & .section-title {
    margin-bottom: 10px;
  }
`;

export const SentToClientContainerStyled = styled.div`
  & .section-title {
    margin-bottom: 10px;
  }
`;

export const UploadedPDFViewWrapperStyled = styled.div`
  position: relative;
  padding-top: 6px;

  & .number-bullet-container {
    position: absolute;
    left: 0px;
    top: 3px;
    z-index: 10;
    & .number-bullet {
      background-color: ${({ theme }) => theme.colors.secondary};
      color: ${({ theme }) => theme.colors.white};
      ${flexCenter()};
      width: 30px;
      height: 30px;
      border-radius: 50%;
    }
  }
`;

export const ReviewHistoryContainerStyled = styled.div<{ $height?: string }>`
  background-color: #fcfcfc;
  padding: 5px 16px;
  height: '100%';
  max-height: ${({ $height }) => $height || 'auto'};
  overflow: hidden;
`;

export const ClientReviewHistoryContainerStyled = styled.div<{
  $height?: string;
}>`
  background-color: #fcfcfc;
  padding: 5px 16px;
  height: '100%';
  max-height: ${({ $height }) => $height || 'auto'};
  overflow: hidden;
`;

export const ClientReviewStyled = styled.div`
  margin-bottom: 50px;
`;
